/* global window */

const dataLayer = window.dataLayer || [];
const fbq = window.fbq || (() => {});

module.exports = {
  dataLayer,
  fbq,
};
